import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { skillCategories } from '@/constants/skills';
import { useSearchParamsContext } from '@/contexts/search-params-context';

import { CollapsibleFilter } from './collapsible-filter';

type SkillsFilterProps = {
  defaultOpen?: boolean;
  className?: string;
};

export const SkillsFilter = ({ defaultOpen, className }: SkillsFilterProps) => {
  const { filters, updateFilter } = useSearchParamsContext();

  const handleSkillToggle = (skill: string, checked: boolean) => {
    const currentSkills = Array.isArray(filters.skills)
      ? [...filters.skills]
      : [];

    if (checked) {
      updateFilter('skills', [...currentSkills, skill]);
    } else {
      updateFilter(
        'skills',
        currentSkills.filter((s) => s !== skill),
      );
    }
  };

  if (!skillCategories) {
    <p className='text-sm text-muted-foreground'>No skills found</p>;
  }

  return (
    <CollapsibleFilter
      title='Skills'
      defaultOpen={defaultOpen}
      className={className}
    >
      <ul className='max-h-36 space-y-1 overflow-y-auto'>
        {[...skillCategories].sort().map((category) => (
          <li key={category}>
            <Label
              className='flex items-start gap-2 text-base font-normal leading-tight'
              htmlFor={category}
            >
              <Checkbox
                id={category}
                className='mt-0.5'
                checked={filters.skills?.includes(category) || false}
                onCheckedChange={(checked) =>
                  handleSkillToggle(category, checked === true)
                }
              />
              {category}
            </Label>
          </li>
        ))}
      </ul>
    </CollapsibleFilter>
  );
};
